import { companyDetails } from 'utils/companyDetails';

export const dataOne = [
  {
    id: 1,
    title: 'Revolutionizing mobility across India',
    content: `At ${companyDetails?.companyName} Mobility, we're passionate about making travel in India seamless, convenient, and accessible for everyone. Inspired by the Latin word "iter" meaning "journey," we strive to redefine your travel experience by offering a comprehensive mobility platform accessible throughout India.`,
  },
  {
    id: 2,
    title: 'Our Mission',
    content: `We believe everyone deserves a safe, reliable, and affordable way to get around. Our mission is to empower individuals and businesses with a user-friendly mobile app that connects them with a network of trusted drivers and diverse transportation options.`,
  },
]

export const aboutListData = [
  {
    title: 'What We Offer',
    body: [
      {
        subTitle: 'On-demand Rides:',
        content: [
          `Book a car, taxi, or other transportation options with just a few taps on your phone. ${companyDetails?.companyName} provides a variety of ride categories to suit your needs and budget.`,
        ]
      },
      {
        subTitle: 'Pan-India Presence:',
        content: [
          `Whether you're in a bustling metro city or a remote town, ${companyDetails?.companyName} connects you with drivers across India, ensuring a ride whenever you need it.`,
        ]
      },
      {
        subTitle: 'Safety First:',
        content: [
          `Your safety is our top priority. We implement comprehensive background checks for drivers and utilize advanced safety features within the app.`,
        ]
      },
      {
        subTitle: 'Seamless Payments:',
        content: [
          `Enjoy a hassle-free experience with secure in-app payment options.`,
        ]
      },
    ]
  }
]

export const dataTwo = [
  {
    id: 1,
    title: 'More Than Just Rides',
    content: `At ${companyDetails?.companyName}, we're committed to being more than just a ride-hailing app. We're building a community that promotes sustainable and efficient transportation solutions across India. We actively explore partnerships with local businesses and transportation authorities to provide innovative mobility options for the future.`,
  },

  {
    id: 2,
    title: `Join the ${companyDetails?.companyName} Journey`,
    content: `Download the ${companyDetails?.companyName} app today and experience a new way to travel in India. We're constantly working to improve our services and expand our reach, so stay tuned for exciting updates!`,
  },
]


export const aboutFaqData = [
  {
    title: 'Booking a Ride',
    body: [
      {
        content: [
          `How do I book a ride using ${companyDetails?.companyName}?.`,
          `Can I schedule a ride for others?`,
          `Can I schedule a ride in advance? `,
          `What if I need to change or cancel my ride?`,
          `How are fares calculated? `,
          `Do we need to register to make a booking? `,
        ]
      },
    ]
  },

  {
    title: 'Pricing related',
    body: [
      {
        content: [
          `How are the fares calculated for each of the duty types?`,
        ]
      },
    ]
  },
  {
    title: 'Payment',
    body: [
      {
        content: [
          ` What payment methods do you accept?`,
          `Can I pay with cash? `,
          `Can I pay for other's trip?`,
          `How do I add a new payment method?`,
          `What are the exclusive charges?`,
          `Are all the services prepaid?`,
          `On cancellation what happens to the payment that has been already made?`,
          `How do I claim my wrong cancellation charges?`,
        ]
      },
    ]
  },
  {
    title: 'Safety and Security',
    body: [
      {
        content: [
          `Is ${companyDetails?.companyName} app safer to install on my mobile?`,
          `How do you ensure the safety of riders and drivers?`,
          `Can I share my ride details with a friend or family member?  `,
        ]
      },
    ]
  },
  {
    title: 'Account and Support',
    body: [
      {
        content: [
          `How do I create an account?`,
          `How do I contact customer support?`,
          `Can I talk to the customer support directly?`,
        ]
      },
    ]
  },
  {
    title: `Additional FAQs specific to ${companyDetails?.companyName}`,
    body: [
      {
        content: [
          `What cities and towns does ${companyDetails?.companyName} operate in?`,
          `What types of vehicles does ${companyDetails?.companyName} offer? `,
          `What is ${companyDetails?.companyName}'s commitment to sustainability?`,
        ]
      },
    ]
  },
]

export const helpData = [
  {
    title: "Getting Started:",
    body: [
      {
        content: [
          `How do I create an account?`,
          `How do I request a ride?`,
          `How do I cancel a ride?`,
          `How do I change my payment method?`,
          `How do I contact customer support?`,
        ],
      },
    ],
  },
  {
    title: "Booking a Ride:",
    body: [
      {
        content: [
          "What are the different types of rides available?",
          "How do I estimate the fare for a ride?",
          "How do I schedule a ride in advance?",
          "How do I add a stop to my ride?",
          "How do I use a promo code?",
        ],
      },
    ],
  },
  {
    title: "During Your Ride:",
    body: [
      {
        content: [
          "How do I track my driver's location?",
          "How do I contact my driver?",
          "How do I share my ride details with others?",
          "How do I report a safety issue?",
          "How do I leave a rating and review for my driver?",
        ],
      },
    ],
  },
  {
    title: "Payment:",
    body: [
      {
        content: [
          "How do I view my past trip history and receipts?",
          "How do I dispute a charge?",
        ],
      },
    ],
  },
  {
    title: "Account:",
    body: [
      {
        content: [
          "How do I update my profile information?",
          "How do I change my password?",
          "How do I manage my notification preferences?",
          "How do I delete my account?",
          "How do I set up a business account?",
        ],
      },
    ],
  },
  {
    title: "Safety and Security:",
    body: [
      {
        content: [
          `What safety features does ${companyDetails?.companyName} offer?`,
          `How does ${companyDetails?.companyName} verify the identity of drivers?`,
          `What is ${companyDetails?.companyName}'s insurance policy?`,
          "How do I report a lost or found item?",
        ],
      },
    ],
  },
  {
    title: "Accessibility:",
    body: [
      {
        content: [
          `How does ${companyDetails?.companyName} support riders with disabilities?`,
          "How can I request a wheelchair-accessible vehicle?",
        ],
      },
    ],
  },
  {
    title: `${companyDetails?.companyName} Specific:`,
    body: [
      {
        content: [
          `What are the benefits of using ${companyDetails?.companyName} over other ride-hailing apps?`,
          `What is ${companyDetails?.companyName}'s commitment to sustainability?`,
          `How can I become a driver for ${companyDetails?.companyName}?`,
        ],
      },
    ],
  },
];


export const privacyPolicyData = [
  {
    title: '',
    body: [
      {
        subTitle: 'Purpose:',
        content: [
          `We may collect your device's location data to provide location-based services,
          such as personalized content, recommendations, or navigation assistance.`,
        ]
      },
      {
        subTitle: 'Data Collection:',
        content: [
          `Your device's location may be collected either while the app is in use or
          in the background, depending on the specific features or functionalities you engage with.`,
        ]
      },
      {
        subTitle: 'Usage:',
        content: [
          `The collected location data is used solely for the purposes stated above and is
          never shared with third parties for marketing or advertising purposes without your
          explicit consent.`,
        ]
      },
    ]
  }
]